import { render, staticRenderFns } from "./PaymentContract.vue?vue&type=template&id=705fe7c6&"
import script from "./PaymentContract.vue?vue&type=script&lang=js&"
export * from "./PaymentContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports